import React, { useEffect } from 'react'
import { Link, NavLink } from "react-router-dom";

import { FaFacebook } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import Aos from "aos";
import 'aos/dist/aos.css';

function Hero() {
  useEffect(()=>{
    Aos.init()
  }, [])
  return (
    <section className='hero'>
      <div className="container position-relative" data-aos="zoom-in" data-aos-easing="ease" data-aos-duration="1500">
        <div className="hero-social d-flex align-items-center justify-content-md-start justify-content-sm-center justify-content-center flex-md-column flex-sm-row flex-row">
          <a href="https://web.facebook.com/NexelisTechnologies" target='blank'><FaFacebook /></a>
          <a href="https://www.instagram.com/nexelistechnologies/" target='blank'><FaInstagram /></a>
          <a href="https://x.com/NexelisTech" target='blank'><FaXTwitter /></a>
          <hr className='d-md-block d-sm-none d-none' />
        </div>
        <div className="d-flex justify-content-center align-items-center flex-column text-center gap-md-3 gap-sm-2 gap-2">
          <h1>Digital Services</h1>
          <h3>Building Your Empire Digitally</h3>
          <div className="d-flex gap-md-4 gap-sm-4 mt-3">
            <Link to = "/service" className="btn_1">Get Started</Link>
            <Link to = "/About" className="btn_2">Discover More</Link>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
